import React, { useState, useEffect } from 'react';
import Button from '../../common/Button/Button';
import styles from './RealisationsPreview.module.css';
import ProjectCard from '../../realisations/ProjectCard/ProjectCard';
import pb from '../../../lib/pocketbase'; // Importer PocketBase



function RealisationsPreview() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const resultList = await pb.collection('projects').getList(1, 3, {
          sort: '-created',
        });
        setProjects(resultList.items);
      } catch (error) {
        console.error("Failed to fetch projects:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);
  return (
    <section className={styles.realisationsSection}>
      <div className="container">
        <div className={styles.realisationsContent}>
          <span className={styles.eyebrow}>Portfolio d'Excellence</span>
          <h2>Découvrez nos réalisations</h2>
          <div className={styles.divider}></div>
          <p>
            Chaque projet est une histoire unique, construite avec passion et savoir-faire. Voici un aperçu de notre travail.
          </p>
          <div className={styles.realisationsGrid}>
            {loading ? (
              <p>Chargement des projets...</p>
            ) : (
              projects.map((project) => (
                <ProjectCard
                  key={project.id}
                  title={project.title}
                  description={project.description.replace(/<[^>]+>/g, '').substring(0, 100) + '...'}
                  imageSrc={pb.getFileUrl(project, project.cover_image)}
                  detailsLink={`/realisations/${project.slug}`}
                />
              ))
            )}
          </div>
          <div className={styles.ctaContainer}>
            <Button to="/realisations" variant="primary">Voir tous nos projets</Button>
          </div>
        </div>
      </div>
    </section>

  );
}

export default RealisationsPreview;
